<template>
  <b-container fluid>
    <h1>Officials Setup</h1>
    <table>
      <thead>
        <tr>
          <th>Referees</th>
          <th>Judges</th>
          <th>Scorekeeper</th>
          <th>Timekeeper</th>
        </tr>
      </thead>
    </table>
    <b-button variant="primary" @click="$emit('next')">Tournament Setup</b-button>
  </b-container>
</template>

<script>
export default {
  name: 'SetupOfficials',
};
</script>

<style scoped>

</style>
